import * as React from "react"
import type { SVGProps } from "react"
const SvgMoney = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M12 15.43q1.25 0 2.13-.88a3 3 0 0 0 .87-2.12q0-1.25-.87-2.13A3 3 0 0 0 12 9.43q-1.25 0-2.12.87A3 3 0 0 0 9 12.43q0 1.25.88 2.12a3 3 0 0 0 2.12.88" />
    <path
      fillRule="evenodd"
      d="M4 19.43q-.82 0-1.41-.59A2 2 0 0 1 2 17.43v-10q0-.82.59-1.41A2 2 0 0 1 4 5.42h16q.83 0 1.41.6.6.59.59 1.4v10q0 .84-.59 1.42a2 2 0 0 1-1.41.59zm13-2q0-1.24.88-2.12a3 3 0 0 1 2.12-.88v-4a3 3 0 0 1-2.12-.88A3 3 0 0 1 17 7.43H7q0 1.23-.88 2.12a3 3 0 0 1-2.12.88v4q1.23 0 2.12.88.88.89.88 2.12z"
      clipRule="evenodd"
    />
  </svg>
)
export default SvgMoney
